import { FC } from 'react';

import LoadingIndicator from 'dashboard/components-lib/LoadingIndicator';
import { MessageType } from 'dashboard/lib/interfaces/Message';
import IntegrationLog from 'dashboard/modules/IntegrationLog';
import { useLazyListExternalIntegrationLogsQuery } from 'dashboard/redux/api/external-integration-log';
import Card from 'design-system/components/Card/Card';
import Spacer from 'design-system/components/Spacer';
import { Heading } from 'design-system/components/Text';
import useOnMount from 'lib/hooks/useOnMount';
import useRTKErrorHandler from 'lib/hooks/useRTKErrorHandler';

const InquiryIntegrationLog: FC<{ inquiryId: string }> = ({ inquiryId }) => {
  const [trigger, { data: { data: logs = [] } = {}, isLoading, error }, _] =
    useLazyListExternalIntegrationLogsQuery();

  useOnMount(() => {
    trigger({ filter: { 'related-object-ids': [inquiryId] } });
  });

  useRTKErrorHandler({
    error,
    onError: (error) => ({
      message:
        error?.errors?.at(0)?.title || 'An error occurred loading the list of Integration Logs.',
      level: MessageType.Failure,
    }),
  });

  if (isLoading) {
    return <LoadingIndicator />;
  } else if (logs.length === 0) {
    return (
      <Card>
        <Card.Body>There are no integration logs for this inquiry.</Card.Body>
      </Card>
    );
  }

  return (
    <>
      {logs.map((log) => (
        <div key={`inquiries-show-view-${log.id}__container`}>
          <Card>
            <Card.Body>
              <Heading size='md'>Integration Log {log.id}</Heading>
            </Card.Body>
          </Card>
          <IntegrationLog key={`inquiries-show-view-${log.id}__log`} token={log.id} />
          {logs.length > 0 && <Spacer height={16} />}
        </div>
      ))}
    </>
  );
};

export default InquiryIntegrationLog;
